<template>
    <DataTable
        :header="$t('products')"
        :fields="fields"
        :items="items"
        :loading="request.getLoading()"
        class="mb-4"
    >
        <template #cell(minPrice)="{value}">
            {{ $format.currency(value) }}
        </template>
        <template #cell(maxPrice)="{value}">
            {{ $format.currency(value) }}
        </template>
        <template #cell(avgPrice)="{value}">
            {{ $format.currency(value) }}
        </template>
    </DataTable>
</template>



<script>
    import DataTable from '@/components/common/DataTable.vue';

    export default {
        name: 'ProductList',
        components: {
            DataTable,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                request: this.parentComponent.requestData1,
            };
        },
        computed: {
            fields() {
                return [
                    { key: 'product.name', label: this.$t('productName'), sortable: true },
                    { key: 'product.ean', label: this.$t('ean'), sortable: true },
                    { key: 'minPrice', label: this.$t('minPrice'), sortable: true, tdClass: 'text-right', thClass: 'text-right' },
                    { key: 'avgPrice', label: this.$t('avgPrice'), sortable: true, tdClass: 'text-right', thClass: 'text-right' },
                    { key: 'maxPrice', label: this.$t('maxPrice'), sortable: true, tdClass: 'text-right', thClass: 'text-right' },
                ];
            },
            items() {
                return this.parentComponent.data.map(item => ({
                    ...item,
                    minPrice: this.getMinPrice(item),
                    avgPrice: this.getAvgPrice(item),
                    maxPrice: this.getMaxPrice(item),
                }));
            },
        },
        methods: {
            getMinPrice(item) {
                const data = Object.values(item.report)
                    .filter(el => el.min)
                    .map(el => el.min);
                return data.length ? Math.min(...data) : null;
            },
            getMaxPrice(item) {
                const data = Object.values(item.report)
                    .filter(el => el.max)
                    .map(el => el.max);
                return data.length ? Math.max(...data) : null;
            },
            getAvgPrice(item) {
                const data = Object.values(item.report)
                    .map(el => el.chart)
                    .flat()
                    .filter(el => el.avg)
                    .map(el => el.avg);
                return this.$utils.avg(...data);
            },
        },
    };
</script>
